import { render } from "./PatientHome.vue?vue&type=template&id=7570dbe2&scoped=true"
import script from "./PatientHome.vue?vue&type=script&lang=js"
export * from "./PatientHome.vue?vue&type=script&lang=js"

import "./PatientHome.vue?vue&type=style&index=0&id=7570dbe2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7570dbe2"]])

export default __exports__